import { render, staticRenderFns } from "./AuthorCell.vue?vue&type=template&id=34372f5c&"
import script from "./AuthorCell.vue?vue&type=script&lang=js&"
export * from "./AuthorCell.vue?vue&type=script&lang=js&"
import style0 from "./AuthorCell.vue?vue&type=style&index=0&id=34372f5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports